import React, { useCallback, useContext } from 'react';

import {
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonToolbar,
} from '@ionic/react';
import {
  checkmarkSharp,
  closeOutline,
  reloadSharp,
  searchOutline,
} from 'ionicons/icons';

import Button from 'components/Button';
import ProgressBar from 'components/ProgressBar';
import Typography from 'components/Typography';

import { ModalContext, ModalProvider } from './ModalContext';
import { IModal, IModalContent } from './interfaces';

export type { IModal } from './interfaces';
export { useModal } from './useModal';
export { useSidePage } from './useSidePage';
export { SidePageRoute } from './SidePageRoute';

export const Modal = ({ onSubmit, onClose, children }: IModal) => {
  return (
    <ModalProvider onClose={onClose} onSubmit={onSubmit}>
      {children}
    </ModalProvider>
  );
};
export const ModalHeader: React.FC = ({ children }: any) => {
  return (
    <IonHeader>
      <IonToolbar>{children}</IonToolbar>
    </IonHeader>
  );
};
export const ModalFooter: React.FC = ({ children }: any) => {
  return (
    <IonFooter>
      <IonToolbar>{children}</IonToolbar>
    </IonFooter>
  );
};
export const ModalSearch: React.FC = () => {
  return (
    <IonButtons slot={'end'}>
      <Button>
        <IonIcon slot={'icon-only'} icon={searchOutline} />
      </Button>
    </IonButtons>
  );
};

export const ModalApplyButton = () => {
  const { onSubmit: contextOnSubmit } = useContext(ModalContext);

  return (
    <Button
      slot={'end'}
      className={'ion-padding-end'}
      color={'primary'}
      onClick={contextOnSubmit}
    >
      <IonIcon icon={checkmarkSharp} color={'medium-contrast'} />
    </Button>
  );
};

export const ModalRefreshButton = ({ onClick }: any) => {
  return (
    <Button
      slot={'end'}
      className={'ion-padding-end'}
      fill={'clear'}
      onClick={onClick}
    >
      <IonIcon icon={reloadSharp} />
    </Button>
  );
};

export const ModalCloseButton: React.FC = () => {
  const { onClose } = useContext(ModalContext);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <IonButtons slot={'start'}>
      <Button onClick={handleClose}>
        <IonIcon slot={'icon-only'} icon={closeOutline} />
      </Button>
    </IonButtons>
  );
};
export const ModalContent = ({
  children,
  isRefetching = false,
  isUpdating = false,
}: IModalContent) => {
  return (
    <IonContent>
      {(isRefetching || isUpdating) && (
        <div slot={'fixed'}>
          <ProgressBar
            type={'indeterminate'}
            className={'modalSubHeaderLoader'}
          />
        </div>
      )}
      {children}
    </IonContent>
  );
};
export const ModalTitle = ({ children }: any) => {
  return <Typography variant={'title'}>{children}</Typography>;
};

export default Modal;
